import { render, staticRenderFns } from "./LmEChartPieBuilder.vue?vue&type=template&id=229ca0e1"
import script from "./LmEChartPieBuilder.vue?vue&type=script&lang=js"
export * from "./LmEChartPieBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports